import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
  const { colors } = useTheme();
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  return (
    <div 
      className="flex items-center justify-between px-6 py-4 border-t"
      style={{ backgroundColor: colors.surfaceHover, borderColor: colors.border }}
    >
      <div className="text-[13px] font-medium" style={{ color: colors.textSecondary }}>
        Showing <span className="font-bold text-[14px]" style={{ color: colors.text }}>{Math.min(totalItems, (currentPage - 1) * itemsPerPage + 1)}</span> to{' '}
        <span className="font-bold text-[14px]" style={{ color: colors.text }}>{Math.min(totalItems, currentPage * itemsPerPage)}</span> of{' '}
        <span className="font-bold text-[14px]" style={{ color: colors.text }}>{totalItems}</span> results
      </div>
      
      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="p-1.5 rounded-lg border transition-all disabled:opacity-50 disabled:cursor-not-allowed hover:bg-black/5"
          style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.backgroundSecondary }}
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <div className="flex items-center px-2 text-[13px] font-bold" style={{ color: colors.text }}>
          {currentPage} / {totalPages}
        </div>
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="p-1.5 rounded-lg border transition-all disabled:opacity-50 disabled:cursor-not-allowed hover:bg-black/5"
          style={{ borderColor: colors.border, color: colors.text, backgroundColor: colors.backgroundSecondary }}
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
